export const DOCUMENT_LINKS = {
  ANTI_CORRUPTION_POLICY:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_Anti+Corruption+Policy_Final.pdf",
  FAIR_PRACTICES_CODE:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_Fair+Practices+Code_Dec+2021_Final.pdf",
  WHISTLEBLOWER:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_WhistleBlower+Policy.pdf",
  NIRO_AML_POLICY:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_AML+Policy_Final.pdf",
  NIRO_SACTION_POLICY:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_Sanctions+Policy_Final.pdf",
  THIRD_PARTY_CODE_OF_CONDUCT:
    "https://niro-policy-docs.s3.ap-south-1.amazonaws.com/Niro_Third+Party+Code+of+Conduct.pdf",
};

export const POLICIES = {
  FAIR_PRACTICES_CODE: "Fair Practices Code",
  ANTI_CORRUPTION_POLICY: "Anti Corruption Policy",
  NIRO_AML_POLICY: "Niro AML Policy",
  NIRO_SACTION_POLICY: "Niro Sanctions Policy",
  THIRD_PARTY_CODE_OF_CONDUCT: "Third party code of conduct",
  WHISTLEBLOWER: "Whistleblower",
};
